import React, { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { connect } from "react-redux";
import { AppState } from "store/types";

type ProtectedRouteProps = {
  children: ReactNode;
  isAuthenticated: boolean;
};

const ProtectedRoute = ({ isAuthenticated, children }: ProtectedRouteProps) => {
  return isAuthenticated ? (
    <>{children}</>
  ) : (
    <Navigate to="/login" replace />
  );
};

const mapStateToProps = (state: AppState) => ({
  isAuthenticated: state.auth.isLoggedIn
});

export default connect(mapStateToProps)(ProtectedRoute);
